var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Navbar"},[_c('b-navbar',{staticClass:"nav",attrs:{"type":"dark","variant":"dark"}},[_c('b-link',{staticClass:"navbar-brand link mx-auto",attrs:{"href":""}},[_vm._v(" { Mohil Palav } ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }